import { graphqlOperationWithTokenRefresh } from './graphqlOperation';
import { GetOffsegMasterInfoWithOrganizationIdQuery, QueryOutputType } from '../type/QueryType';
import { offsegGetType } from '../const/commonConst';
import { GetMasterInfoInput } from '../../API';

const queryGetCarAndDriverInfo = /* GraphQL */ `
	query GetOffsegMasterInfoWithOrganizationId($input: GetMasterInfoInput!) {
		getOffsegCarInfo(input: $input) {
			responseType
			message
			carInfoList {
				carId
				carCode
				numberPlate
				organizationName
			}
		}
		getOffsegDriverInfo(input: $input) {
			responseType
			message
			driverInfoList {
				driverId
				driverName
			}
		}
	}
`;

const queryGetOnlyDriverInfo = /* GraphQL */ `
	query GetOffsegMasterInfoWithOrganizationId($input: GetMasterInfoInput!) {
		getOffsegDriverInfo(input: $input) {
			responseType
			message
			driverInfoList {
				driverId
				driverName
			}
		}
	}
`;

/**
 * マスタ情報取得APIを呼び出す
 */
export const queryGetOffsegMasterInfoWithOrganizationId = async (
	getType: (typeof offsegGetType)[keyof typeof offsegGetType],
	getMasterInfoInput: GetMasterInfoInput,
	authorizationToken: string,
): Promise<QueryOutputType<GetOffsegMasterInfoWithOrganizationIdQuery>> => {
	const query = getType === offsegGetType.carAndDriverInfo ? queryGetCarAndDriverInfo : queryGetOnlyDriverInfo;

	const apiResponse = await graphqlOperationWithTokenRefresh<GetOffsegMasterInfoWithOrganizationIdQuery>(
		query,
		{ input: getMasterInfoInput },
		authorizationToken,
	);
	console.log(apiResponse);

	return apiResponse;
};
